import { Badge, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
const { Text } = Typography;

export default function NewStatementStatus({
  statusObj
}) {

  // @TODO - Handle status for review below
  const {
    newStatement,
    status,
    patching,
    shouldPersist
  } = statusObj;

  return <>
    {
      ((!shouldPersist && status) || (shouldPersist && !status)) && !patching
        && <Text type="secondary"><Badge status="default" /> { newStatement ? 'Ready to generate' : 'Ready'}</Text>
      }
    {
      patching
        && <Text> <Badge status="processing" /> { newStatement ? 'Creating...' : 'Patching...'} <LoadingOutlined/></Text>
      }
    {
      ((newStatement && shouldPersist && status) || (!newStatement && status)) && !patching
        && <Text type="success"><Badge status="success" /> { newStatement ? 'Created' : 'Patched'}</Text>
      }
  </>;
}